import "./noChat.scss";
import Avatar from "@mui/material/Avatar";
import { Button, Typography } from "@mui/material";
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { lightBlue } from "@mui/material/colors";

const NoChat = () => {
  return (
    <>
      <div className="noChat-blk">
        <div>
        <Avatar  sx={{boxShadow: 1, bgcolor: lightBlue[50], width: '85px', height: '85px', margin: '0 auto' }}><ForumOutlinedIcon sx={{fontSize: '5rem', color: lightBlue[500]}} /></Avatar>
          <div>
            <Typography sx={{ mt: 1, fontSize: '2.3rem'  }}  component="div">
            Choose a conversation to proceed!
            </Typography>
            <Typography component="p"> Don't miss out on the chance to connect with students in real-time and provide personalized assistance. Start promoting your WhatsApp number now and watch your student engagement soar!</Typography>
          </div>
          {/* <Typography sx={{ mt: 2 }}  component="div">
            <Button variant="contained"> Code for whatsapp widget</Button>
          </Typography> */}
          </div>
      </div>
    </>
  );
};

export default NoChat;
